<template>
<v-card class="crud-dialog">
  <v-card-title class="headline">
    <v-icon>add</v-icon> Agregar documento del trámite de la entidad
    <v-btn icon @click.native="$store.commit('closeModal', 3)">
      <v-icon>close</v-icon>
    </v-btn>
  </v-card-title>
  <v-card-text>
    <v-alert
      color="info"
      icon="info"
      :value="true">
      Se agregará el trámite de la entidad en base a los trámites registrados en el <strong>Portal único de trámites</strong> y la <strong>Plataforma de pagos</strong>.
    </v-alert>
    <v-select
      :items="mydocs.portal"
      v-model="documento"
      label="Documentos"
      item-text="nombre"
      item-value="codigo_portal"
      autocomplete
      noDataText="No hay resultados"></v-select>
    <div v-if="showUsuariosApp">
      <v-alert
        color="info"
        icon="info"
        v-if="mydocs.usuariosApp.length > 1"
        :value="true">
        Seleccione una Aplicación que esté asociada al trámite que quiere crear, de la misma forma en que lo hace en la Plataforma de Pagos
      </v-alert>
      <v-select
        :items="mydocs.usuariosApp"
        v-model="usuarioapp"
        label="Aplicación en la Plataforma de pago"
        item-text="endpoint"
        item-value="id_usuario_app"
        :readonly="mydocs.usuariosApp.length == 1"
        autocomplete
        noDataText="No hay resultados"></v-select>
    </div>
    <v-alert
      v-if="!showUsuariosApp && documento"
      color="warning"
      icon="warning"
      :value="true">
      El documento seleccionado no tiene asociado ninguna Aplicación en la Plataforma de Pagos
    </v-alert>
  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn
      @click.native="$store.commit('closeModal', 3)">
      <v-icon>cancel</v-icon> Cancelar
    </v-btn>
    <v-btn
      color="primary"
      @click="obtainTokenForDocument()"
      :disabled="!show || loading">
      <v-icon>check_circle</v-icon> Crear trámite
    </v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
export default {
  data () {
    return {
      documento: null,
      usuarioapp: null,
      show: false,
      showUsuariosApp: false,
      idEntidadPPTE: null,
      idTramtie: null,
      loading: false
    };
  },
  props: ['mydocs'],
  methods: {
    obtainTokenForDocument () { // get number of tramites. send idEndidad e idTramite en PPTE
      let datos = this.mydocs.portal.filter(x => x.codigo_portal === this.documento)[0]; // this.documento tiene el codigo_portal en objetos de mydocs.portal
      let montosDatosTramitesEntidadPpte = this.montos; // Obteniendo montos de datosTramitesEntidadPpte

      let montosCuentas = [];
      for (let i in montosDatosTramitesEntidadPpte) {
        let Monto = montosDatosTramitesEntidadPpte[i].monto;
        let Cuenta = montosDatosTramitesEntidadPpte[i].cuenta.cuenta;
        montosCuentas.push({monto: Monto, cuenta: Cuenta});
      }
      datos.monto = montosCuentas;

      this.loading = true;
      this.$service.post(`eapostilla/obtener_token_tramite/${this.idEntidadPPTE}/${this.idTramite}/${this.usuarioapp.id_usuario_app ? this.usuarioapp.id_usuario_app : this.usuarioapp}`, datos)
      .then(response => {
        this.loading = false;
        if (response) {
          this.show = false;
          this.showUsuariosApp = false;
          this.idEntidadPPTE = null;
          this.idTramite = null;
          this.$store.commit('closeModal', 3);
          this.$message.success('Se agregó el documento correctamente.');
          document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
        }
      });
    }
  },
  computed: {
    obtenerCodigosPortalDeTramitesEnPpte: function () {
      return this.mydocs.datosTramitesEntidadPpte.map(x => x.codigoPortalUnico);
    }
  },
  watch: {
    documento: function (val) {
      if (this.obtenerCodigosPortalDeTramitesEnPpte.includes(val.toString())) { // codigo PortalTramites existe en PPTE?
        this.showUsuariosApp = true;
        this.idTramite = this.mydocs.datosTramitesEntidadPpte.filter(x => x.codigoPortalUnico === val.toString())[0].id;
        this.montos = this.mydocs.datosTramitesEntidadPpte.filter(x => x.codigoPortalUnico === val.toString())[0].montos;

        if (this.mydocs.usuariosApp && this.mydocs.usuariosApp.length === 1) {
          this.usuarioapp = this.mydocs.usuariosApp[0];
        }
      } else {
        this.showUsuariosApp = false;
        this.usuarioapp = null;
      }
      console.log('Documentos del portal de trámites: ' + JSON.stringify(this.mydocs));

      this.show = false;
    },
    usuarioapp: function (val) {
      if (val) {
        this.show = true;
        if (this.mydocs.usuariosApp.length === 1) {
          if (val.id_entidad) {
            this.idEntidadPPTE = val.id_entidad;
          }
        } else {
          this.idEntidadPPTE = this.mydocs.usuariosApp.filter(x => x.id_usuario_app === val)[0].id_entidad;
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// AddDocs.vue?cf9c78ca